exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Icon-b8e983af{display:inline-block;vertical-align:middle;text-align:center;font-size:0;line-height:0}.Icon-b8e983af svg{height:100%;width:auto;fill:currentColor;stroke:currentColor}.alignMiddle-43f0d511 svg{vertical-align:middle}\n", ""]);

// Exports
exports.locals = {
	"Icon": "Icon-b8e983af",
	"alignMiddle": "alignMiddle-43f0d511"
};